<template>
  <div style="padding-top:20px">
    <el-row :gutter="23">
      <el-col :span="18">
        <el-form :inline="true" :model="params" class="user-search">
          <el-form-item label="">
            <el-cascader v-model="country_business_name" :options="country_business" size="small"
              :props="{ checkStrictly: true,value:'name',label:'name',expandTrigger: 'hover'}" clearable
              placeholder="Country/Business" @change="cascaderChange" style="position:relative;right:2px">
            </el-cascader>
          </el-form-item>
          <el-select size="small" v-model="params.type" clearable placeholder="Type"
            style="width:140px;position:relative;top: 5px;right:5px">
            <el-option v-for="item in type_list" :key="item.k" :label="item.v" :value="item.k">
            </el-option>
          </el-select>
          <el-form-item label="" v-if="params.type==5">
            <el-date-picker v-model="params.date" type="daterange" size="small" value-format="yyyy-MM-dd" align="right"
              unlink-panels start-placeholder="Start date" end-placeholder="End date" :picker-options="pickerOptions"
              clearable style="position:relative;">
            </el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-button size="small" type="primary" icon="el-icon-search" @click="search">Search</el-button>
          </el-form-item>
        </el-form>
      </el-col>
    </el-row>
    <!-- 统计图 -->
    <el-row :gutter="23">
      <div class="st-gbox">
        <div class="cavasbox" ref="RechargeEchart"></div>
      </div>
    </el-row>
    <el-row :gutter="23">
      <div class="st-gbox">
        <div class="cavasbox" ref="RechargeAmountEchart"></div>
      </div>
    </el-row>
    <!-- 统计图 -->
    <el-row :gutter="23">
      <div class="st-gbox">
        <div class="cavasbox" ref="WithdrawEchart"></div>
      </div>
    </el-row>
    <el-row :gutter="23">
      <div class="st-gbox">
        <div class="cavasbox" ref="WithdrawAmountEchart"></div>
      </div>
    </el-row>
  </div>
</template>

<script type="text/ecmascript-6">
  import Chart from 'echarts'
  import {
    getCountryBusiness,
    businessChart
  } from '../../api/apiFun'
  import {
    cascaderChange,
  } from '@/utils/util';
  export default {
    data() {
      return {
        country_business: [],
        country_business_name: [
          'Rwandan', 'Rwanda888'
        ],
        params: {
          date: '',
          type: '1',
          business_name: 'Rwanda888',
          country: ''
        },
        type_list: [{
            k: '1',
            v: 'TODAY'
          },
          {
            k: '2',
            v: 'LAST 10 DAYS'
          },
          {
            k: '5',
            v: 'CUSTOM'
          }
        ],
        pickerOptions: {},
        //  Recharge Num 
        RechargeEoption: {
          tooltip: {
            trigger: 'item',
            formatter: "{a} <br/>{b} : {c}"
          },
          legend: {
            data: [{
              name: 'Recharge Num',
              icon: 'rect'
            }],
            top: 1,
            left: 1,
            itemGap: 10,
            itemWidth: 12,
            itemHeight: 12,
            textStyle: {
              fontSize: 12,
              color: "#323232"
            }
          },
          grid: {
            left: 50,
            right: 10,
            top: 30,
            bottom: 30,
            borderWidth: 1
          },
          xAxis: {
            type: 'category',
            data: ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12'],
            axisLine: {
              lineStyle: {
                color: "#999999",
                width: 1
              }
            },
            axisLabel: {
              margin: 14,
              height: 70,
              interval: 0,
              textStyle: {
                fontSize: 10,
                color: "#999999"
              }
            }
          },
          yAxis: {
            type: 'value',
            axisLine: {
              lineStyle: {
                color: "#999999",
                width: 1
              }
            },
            axisLabel: {
              margin: 14,
              textStyle: {
                fontSize: 10,
                color: "#999999"
              }
            }
          },
          series: [{
            name: 'Recharge Num',
            type: 'bar',
            barGap: 0,
            data: [50000, 70000, 80000, 40000, 50000, 300000, 40000, 60000, 150000, 40000, 60000, 140000],
            barWidth: 10,
            itemStyle: {
              normal: {
                color: new Chart.graphic.LinearGradient(
                  0, 0, 0, 1,
                  [{
                      offset: 0,
                      color: '#11aab233'
                    },
                    {
                      offset: 0.5,
                      color: '#00b8c2'
                    },
                    {
                      offset: 1,
                      color: '#00b8c2'
                    }
                  ]
                )
              },
              emphasis: {
                color: new Chart.graphic.LinearGradient(
                  0, 0, 0, 1,
                  [{
                      offset: 0,
                      color: '#00b8c2'
                    },
                    {
                      offset: 0.7,
                      color: '#00b8c2'
                    },
                    {
                      offset: 1,
                      color: '#11aab233'
                    }
                  ]
                )
              }
            }
          }]
        },
        //  Recharge Amount 
        RechargeAmountoption: {
          tooltip: {
            trigger: 'item',
            formatter: "{a} <br/>{b} : {c}"
          },
          legend: {
            data: [{
              name: 'Recharge Amount',
              icon: 'rect'
            }],
            top: 1,
            left: 1,
            itemGap: 10,
            itemWidth: 12,
            itemHeight: 12,
            textStyle: {
              fontSize: 12,
              color: "#323232"
            }
          },
          grid: {
            left: 50,
            right: 10,
            top: 30,
            bottom: 30,
            borderWidth: 1,
          },
          xAxis: {
            type: 'category',
            data: ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12'],
            axisLine: {
              lineStyle: {
                color: "#999999",
                width: 1
              }
            },
            axisLabel: {
              margin: 14,
              height: 70,
              interval: 0,
              textStyle: {
                fontSize: 10,
                color: "#999999"
              }
            }
          },
          yAxis: {
            type: 'value',
            axisLine: {
              lineStyle: {
                color: "#999999",
                width: 1
              }
            },
            axisLabel: {
              formatter: function (value) {
                return (value / 10000) + 'w';
              },
              margin: 14,
              textStyle: {
                fontSize: 10,
                color: "#999999"
              }
            }
          },
          series: [{
            name: 'Recharge Amount',
            //   type: 'bar',
            type: 'line',
            barGap: 0,
            data: [50000, 70000, 80000, 40000, 50000, 30000, 40000, 60000, 50000, 40000, 60000, 40000],
            barWidth: 10,
            itemStyle: {
              color: "#00b8c2"
            }
          }]
        },
        //  Withdraw Num 
        WithdrawEoption: {
          tooltip: {
            trigger: 'item',
            formatter: "{a} <br/>{b} : {c}"
          },
          legend: {
            data: [{
              name: 'Withdraw Num',
              icon: 'rect'
            }],
            top: 1,
            left: 1,
            itemGap: 10,
            itemWidth: 12,
            itemHeight: 12,
            textStyle: {
              fontSize: 12,
              color: "#323232"
            }
          },
          grid: {
            left: 50,
            right: 10,
            top: 30,
            bottom: 30,
            borderWidth: 1
          },
          xAxis: {
            type: 'category',
            data: ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12'],
            axisLine: {
              lineStyle: {
                color: "#999999",
                width: 1
              }
            },
            axisLabel: {
              margin: 14,
              height: 70,
              interval: 0,
              textStyle: {
                fontSize: 10,
                color: "#999999"
              }
            }
          },
          yAxis: {
            type: 'value',
            axisLine: {
              lineStyle: {
                color: "#999999",
                width: 1
              }
            },
            axisLabel: {
              margin: 14,
              textStyle: {
                fontSize: 10,
                color: "#999999"
              }
            }
          },
          series: [{
            name: 'Withdraw Num',
            type: 'bar',
            barGap: 0,
            data: [50000, 70000, 80000, 40000, 50000, 300000, 40000, 60000, 150000, 40000, 60000,
              140000
            ],
            barWidth: 10,
            itemStyle: {
              normal: {
                color: new Chart.graphic.LinearGradient(
                  0, 0, 0, 1,
                  [{
                      offset: 0,
                      color: '#83bff6'
                    },
                    {
                      offset: 0.5,
                      color: '#188df0'
                    },
                    {
                      offset: 1,
                      color: '#188df0'
                    }
                  ]
                )
              },
              emphasis: {
                color: new Chart.graphic.LinearGradient(
                  0, 0, 0, 1,
                  [{
                      offset: 0,
                      color: '#2378f7'
                    },
                    {
                      offset: 0.7,
                      color: '#2378f7'
                    },
                    {
                      offset: 1,
                      color: '#83bff6'
                    }
                  ]
                )
              }
            }
          }]
        },
        //  Withdraw Amount 
        WithdrawAmountoption: {
          tooltip: {
            trigger: 'item',
            formatter: "{a} <br/>{b} : {c}"
          },
          legend: {
            data: [{
              name: 'Withdraw Amount',
              icon: 'rect'
            }],
            top: 1,
            left: 1,
            itemGap: 10,
            itemWidth: 12,
            itemHeight: 12,
            textStyle: {
              fontSize: 12,
              color: "#323232"
            }
          },
          grid: {
            left: 50,
            right: 10,
            top: 30,
            bottom: 30,
            borderWidth: 1
          },
          xAxis: {
            type: 'category',
            data: ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12'],
            axisLine: {
              lineStyle: {
                color: "#999999",
                width: 1
              }
            },
            axisLabel: {
              margin: 14,
              height: 70,
              interval: 0,
              textStyle: {
                fontSize: 10,
                color: "#999999"
              }
            }
          },
          yAxis: {
            type: 'value',
            axisLine: {
              lineStyle: {
                color: "#999999",
                width: 1
              }
            },
            axisLabel: {
              formatter: function (value) {
                return (value / 10000) + 'w';
              },
              margin: 14,
              textStyle: {
                fontSize: 10,
                color: "#999999"
              }
            }
          },
          series: [{
            name: 'Withdraw Amount',
            //   type: 'bar',
            type: 'line',
            barGap: 0,
            data: [50000, 70000, 80000, 40000, 50000, 30000, 40000, 60000, 50000, 40000, 60000,
              40000
            ],
            barWidth: 10,
            itemStyle: {
              color: "#108ff9"
            }
          }]
        },
      }
    },
    // 导入组件
    components: {
      // 点聚合组件
    },
    // 创建完毕状态(里面是操作)
    created() {
      this.getCountryBusiness()
      this.businessChart(this.params)
    },
    // 里面的函数只有调用才会执行
    methods: {
      businessChart(params) {
        if (!this.params.business_name && !this.params.country) {
          this.$message.error('Please select a country or business!')
          return
        }
        if (!this.params.type) {
          this.$message.error('Please select query type!')
          return
        }
        businessChart(params).then(res => {
          if (res.code == 400) {
            this.$message({
              state: 'info',
              message: res.msg
            })
          } else {
            this.RechargeEoption.xAxis.data = this.RechargeAmountoption.xAxis.data = this.WithdrawEoption.xAxis
              .data = this.WithdrawAmountoption.xAxis.data = res.datas.labels

            this.RechargeEoption.series[0].data = res.datas.labels_data.reserved_count
            this.RechargeAmountoption.series[0].data = res.datas.labels_data.reserved_amount
            this.WithdrawEoption.series[0].data = res.datas.labels_data.transaction_count
            this.WithdrawAmountoption.series[0].data = res.datas.labels_data.transaction_amount
            this.getRechargeE()
            this.getRechargeAmount()
            this.getWithdrawE()
            this.getWithdrawAmount()
          }
        }).catch(err => {
          this.$message.error('Failed to obtain business list, please try again later!')
        })
      },
      search() {
        this.businessChart(this.params)
      },
      getCountryBusiness() {
        getCountryBusiness().then(res => {
          if (res.code == 400) {
            this.$message({
              state: 'info',
              message: res.msg
            })
          } else {
            this.country_business = res.datas;
          }
        }).catch(err => {
          this.$message.error('Failed to obtain business list, please try again later!')
        })
      },
      cascaderChange(value) {
        var cascader = cascaderChange(value)
        this.params.country = cascader[0]
        this.params.business_name = cascader[1]
      },
      // 交易总笔数
      getRechargeE() {
        this.chart = Chart.init(this.$refs.RechargeEchart)
        this.chart.setOption(this.RechargeEoption)
      },
      // 交易总金额
      getRechargeAmount() {
        this.chart = Chart.init(this.$refs.RechargeAmountEchart)
        this.chart.setOption(this.RechargeAmountoption)
      },
      // 交易总笔数
      getWithdrawE() {
        this.chart = Chart.init(this.$refs.WithdrawEchart)
        this.chart.setOption(this.WithdrawEoption)
      },
      // 交易总金额
      getWithdrawAmount() {
        this.chart = Chart.init(this.$refs.WithdrawAmountEchart)
        this.chart.setOption(this.WithdrawAmountoption)
      },
    }
  };

</script>
<style>
  .stbox {
    width: 100%;
    height: 100%;
    box-sizing: border-box;
  }

  .stbgc {
    background-color: #fff;
    height: 60px;
    line-height: 60px;
    border-radius: 5px;
    padding: 0px 16px;
  }

  .stsearch {
    text-align: center;
  }

  .text-c {
    text-align: center;
  }

  .st-gbox {
    background-color: #fff;
    margin-top: 20px;
    border-radius: 5px;
    height: 30vh;
    box-sizing: border-box;
    padding: 10px;
  }

  .cavasbox {
    box-sizing: border-box;
    width: 100%;
    height: 100%;
  }

  .paybox {
    width: 100%;
    background-color: #fff;
    box-sizing: border-box;
    border-radius: 5px;
    margin-top: 20px;
    height: 32vh;
  }

</style>



// WEBPACK FOOTER //
// src/views/business/business_chart.vue